"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentEnv = void 0;

var _constants = require("./constants");

var _helpers = require("./helpers");

var getCurrentEnv = function getCurrentEnv(context) {
  var env = context === null || context === void 0 ? void 0 : context.env;
  var keyWord = (0, _helpers.getDomain)(env);
  return keyWord ? _constants.DOMAINS_ENVS[keyWord] : null;
};

exports.getCurrentEnv = getCurrentEnv;
//# sourceMappingURL=get-current-env.js.map